import { bigQuery } from '@fiverr-private/obs';
import { BigQueryEvents } from '../bigQuery';
import { ImpressionEvents } from '../impression';
import { MixpanelEvents } from '../mixpanel';
import { reportMixpanelEvent } from '../mixpanel/reporter';

export const ReportingChannelType = {
    BIG_QUERY: {
        name: 'bigQuery',
        events: BigQueryEvents,
        reporter: bigQuery.send,
    },
    MIXPANEL: {
        name: 'mixpanel',
        events: MixpanelEvents,
        reporter: reportMixpanelEvent,
    },
    IMPRESSION: {
        name: 'impression',
        events: ImpressionEvents,
        reporter: bigQuery.send,
    },
};

export const DEFAULT_REPORTED_CHANNELS = [
    ReportingChannelType.BIG_QUERY,
    ReportingChannelType.IMPRESSION,
    ReportingChannelType.MIXPANEL,
];
